<ng-container [ngSwitch]="errorStatus">
  <ng-container *ngSwitchCase="CustomHttpStatusCode.BadRequest">
    <p class="no-info">Возникла непредвиденная ошибка, повторите попытку позже</p>
  </ng-container>

  <ng-container *ngSwitchCase="CustomHttpStatusCode.Forbidden">
    <p class="no-info">У вас недостаточно прав для просмотра этого раздела</p>
  </ng-container>

  <ng-container *ngSwitchCase="CustomHttpStatusCode.NotFound">
    <p class="no-info">Информация отсутствует</p>
  </ng-container>

  <ng-container *ngSwitchCase="CustomHttpStatusCode.InternalServerError">
    <p class="no-info">Возникла непредвиденная ошибка, повторите попытку позже</p>
  </ng-container>

  <ng-container *ngSwitchCase="CustomHttpStatusCode.GatewayTimeout">
    <p class="no-info">Возникла непредвиденная ошибка, повторите попытку позже</p>
  </ng-container>

  <ng-container *ngSwitchDefault>
    <p class="no-info">Информация отсутствует</p>
  </ng-container>
</ng-container>
